import {Rank} from '/constant/TestIDs';
import {
  ASSOCIATE_DIRECTOR,
  DIRECTOR,
  EXECUTIVE_DIRECTOR,
  GLOBAL_DIRECTOR,
  INTEGRATED_EXECUTIVE_DIRECTOR,
  INTEGRATED_GLOBAL_DIRECTOR,
  INTEGRATED_NATIONAL_DIRECTOR,
  INTEGRATED_PRESIDENTIAL_DIRECTOR,
  INTEGRATED_REGIONAL_DIRECTOR,
  MANAGER,
  NATIONAL_DIRECTOR,
  PRESIDENTIAL_DIRECTOR,
  REGIONAL_DIRECTOR,
  SENIOR_COACH,
} from '/enum/rank.enum';
import {withTranslation} from '/provider/TranslationProvider';

import NumericData from '../../NumericData';

const tt = (key: any, value: any) =>
  withTranslation.tt(`rankProgressCard.groupQualifyingVolume.${key}`, value);

export default {
  dataComponent: NumericData,
  dataComponentProps: {
    getTitle: () => tt('title', 'Group Qualifying Volume (GQV)'),
  },
  extendedDataComponent: undefined,
  extendedDataComponentProps: {},
  isComplete: ({current, target}: any) =>
    parseInt(current, 10) >= parseInt(target, 10),
  hasExtendedDetail: false,
  presentedFor: [
    SENIOR_COACH,
    MANAGER,
    ASSOCIATE_DIRECTOR,
    DIRECTOR,
    EXECUTIVE_DIRECTOR,
    REGIONAL_DIRECTOR,
    NATIONAL_DIRECTOR,
    GLOBAL_DIRECTOR,
    PRESIDENTIAL_DIRECTOR,
    INTEGRATED_REGIONAL_DIRECTOR,
    INTEGRATED_NATIONAL_DIRECTOR,
    INTEGRATED_GLOBAL_DIRECTOR,
    INTEGRATED_PRESIDENTIAL_DIRECTOR,
    INTEGRATED_EXECUTIVE_DIRECTOR,
  ],
  testID: Rank.rankGQV,
};
